export const theme = {
  color: {
    yellow: {
      main: "#FBB943",
      hov: "#FCD285",
    },
    lightBlue: {
      main: "#189EFF",
      hov: "#69C0FF",
    },
    clay: {
      light: "#F1E7CC",
      mid: "#EEE8DD",
      dark: "#9B8E77",
    },
    leads: {
      new: "#E2DACB",
      contacted: "#DBD1BE",
      interested: "#CFC1A8",
      user: "#D7B06B",
    },
    grey: {
      dark: "#3D3D3D",
      mid: "#4A4A4A",
      light: {
        1: "#B0B0B0",
        2: "#F1F1F1",
      },
    },
    background: {
      app: "#FAFAFA",
      sand: "#FFF9F0",
      grey: {
        light: "#E5E5E5",
      },
    },
    white: "#FFFFFF",
    black: "#242424",
    green: "#33AA44",
    tillable: "#607630",
    pasture: "#979E68",
    hunting: "#9E8C68",
    timber: "#6D6450",
    reserve: "#346A6F",
    red: "#D0021B",
    orange: {
      mid: "#FF9051",
    },
    disabled: "#D8DCE6",
    gradient: {
      grey: {
        light: "linear-gradient(0deg, #F6F7F9 2.43%, #FFFFFF 100%)",
      },
    },
  },
  font: {
    size: {
      10: "0.625rem",
      12: "0.750rem",
      15: "0.938rem",
      20: "1.25rem",
      25: "1.563rem",
      30: "1.875rem",
      40: "2.5rem",
    },
    lineHeight: "1.5rem",
    weight: {
      regular: 400,
      semiBold: 600,
      bold: 700,
    },
  },
  gap: {
    xs: "0.313rem",
    s: "0.625rem",
    m: "1.25rem",
    l: "1.875rem",
    xl: "3.125rem",
  },
  shadow: {
    card: "0px 3px 8px rgba(0, 0, 0, 0.05)",
    sidebar: "0px 0px 10px rgba(84, 84, 84, 0.05)",
    header: "0px 1px 0px #EAEDF3, 0px 1px 3px rgba(0, 0, 0, 0.05)",
  },
  border: {
    radius: {
      default: "5px",
      full: "50px",
      main: "5px",
    },
  },
  transition: {
    main: "all 0.2s ease-in-out",
  },
  spacing: (pixel) => `${0.063 * pixel}rem`,
};
